interface DatePickerProps {
  label?: string
  value?: string
  onChange: (date: string) => void
  error?: string
  maxDate?: Date
  minDate?: Date
  placeholder?: string
  id?: string
  name?: string
}

const DatePicker = ({
  label,
  value,
  onChange,
  error,
  maxDate,
  minDate,
  placeholder = "Select date",
  id,
  name,
}: DatePickerProps) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, "-") || 'datepicker'

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const baseInputClassName = `w-full p-4 border rounded-xl outline-none transition-colors ${
    error
      ? "border-error-500 focus:border-error-500"
      : "border-neutral-400 focus:border-neutral-600 hover:border-neutral-500"
  }`

  return (
    <div className="w-full flex flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="text-[18px] font-bold">
          {label}
        </label>
      )}
      
      <input
        id={inputId}
        name={name}
        type="date"
        className={baseInputClassName}
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        max={maxDate ? maxDate.toISOString().split('T')[0] : undefined}
        min={minDate ? minDate.toISOString().split('T')[0] : undefined}
      />
      
      {error && (
        <span className="text-[16px] font-bold text-error-500">{error}</span>
      )}
    </div>
  )
}

export default DatePicker